export default __webpack_public_path__ + "static/media/RizadaCristal.c51b027d.jpg";